import { notify } from '@yembo/yemblocks-core';
import { parseErrorMessage } from 'src/api/_util/parseErrorMessage';
import { getYemboAxiosDefaultHeaders } from 'src/util/getYemboAxiosDefaultHeaders';
import { SILENT_ERROR } from '../../_util/types';
import { appendUrlParams } from './_util/appendUrlParams';
import { makeRequest } from './_util/makeRequest';
import { getCancelSource } from './_util/requestsInFlight/getCancelSource';
import { getRequestId } from './_util/requestsInFlight/getRequestId';
import { addRequestInFlight, cancelEarlierRequests } from './_util/requestsInFlight/index';

// biome-ignore lint/suspicious/noExplicitAny: legacy API call interface accepts arbitrary props
export const yemboApiCall = async (props: Record<string, any>): Promise<unknown> => {
  try {
    props.data = props.data || {};
    props.url = appendUrlParams(props as unknown as Parameters<typeof appendUrlParams>[0]);
    props.cancelSource = getCancelSource();
    props.id = getRequestId();

    const isFormData = props.data instanceof FormData;

    props.headers = {
      ...props.headers,
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...getYemboAxiosDefaultHeaders(),
    };

    addRequestInFlight(props as unknown as Parameters<typeof addRequestInFlight>[0]);

    cancelEarlierRequests(props as unknown as Parameters<typeof cancelEarlierRequests>[0]);

    props.response = await makeRequest(props as unknown as Parameters<typeof makeRequest>[0]);

    return props.response;
  } catch (error) {
    const ignoreError = (error as Error).message === SILENT_ERROR;
    const hasCustomOnError = Boolean(props.onError);

    if (ignoreError) {
      return;
    } else if (hasCustomOnError) {
      return props.onError(error);
    } else {
      // biome-ignore lint/suspicious/noConsole: error logging fallback when no custom onError handler
      console.log({ error }, (error as Error).stack);
      notify.error(parseErrorMessage(error as Error));
    }
  }
};
